<template lang="pug"></template>

<script>
import BotaoListaArmazem from './BotaoListaArmazem.vue';
import BotaoSaldoArmazem from './BotaoSaldoArmazem.vue';

export default {
    name: 'BotaoArmazem',
    componentOptions: {
        title: 'Armazém',
        actions: [
            [
                {
                    name: 'Armazém',
                    iconClass: 'lyra-icon lyra-armazem',
                    showView: false,
                    action: 'abrirArmazem',
                    route: 'armazem',
                    submenus: [
                        BotaoListaArmazem,
                        BotaoSaldoArmazem
                    ]
                }
            ]
        ]
    },

    methods: {
        abrirArmazem() {
            if (this.$route.name !== 'armazem') {
                this.$router.push({ name: 'armazem' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
